import React from 'react';
import { Popover } from '@mui/material';
import * as yup from 'yup';
import {
  SparkForm,
  SparkFormButton,
  SparkTextField,
} from 'sharedComponents/SparkForm';

export type CreateFavouriteListFormValues = {
  listName: string;
};

type CreateFavouriteListPopUpProps = {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  handleClose: () => void;
  onCreateList: (values: CreateFavouriteListFormValues) => void;
};
function CreateFavouriteListPopUp({
  open,
  anchorEl,
  handleClose,
  onCreateList,
}: CreateFavouriteListPopUpProps) {
  const initialValues = {
    listName: '',
  };
  const validationSchema = yup.object().shape({
    listName: yup.string().required(),
  });
  const _onCreateList = (formValues: CreateFavouriteListFormValues) => {
    onCreateList(formValues);
    handleClose();
  };
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClick={(e) => e.stopPropagation()}
      onClose={(e) => {
        //@ts-ignore
        e.stopPropagation();
        handleClose();
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '8px',
          width: '15%',
        },
      }}
    >
      <SparkForm<CreateFavouriteListFormValues>
        initialValues={initialValues}
        onSave={_onCreateList}
        validationSchema={validationSchema}
        sx={{ padding: 2 }}
      >
        <SparkTextField
          name='listName'
          label='Create List'
          placeholder='Enter List Name'
          size={12}
        />
        <SparkFormButton>Create list</SparkFormButton>
      </SparkForm>
    </Popover>
  );
}

export default CreateFavouriteListPopUp;
